import {useCallback, useEffect, useState} from "react";
import {useParseChildren} from "../../../hooks/children-interaction.hooks.js";
const VALIDATE_ELEMENTS = ["Input", "Checkbox", "CheckboxGroup", "ColorPicker", "ImageUploader", "Select"];
export function useFormRefs(children) {
  const [refs, setRefs] = useState([]);
  const [refChildren, setRefChildren] = useState([]);
  const condition = useCallback((elementChild) => typeof elementChild.type === "object" && "displayName" in elementChild.type && VALIDATE_ELEMENTS.includes(elementChild.type["displayName"]), []);
  const getRefs = useParseChildren({
    condition
  });
  useEffect(() => {
    const [referencedChildren, arrayRefs] = getRefs(children);
    setRefs(arrayRefs);
    setRefChildren(referencedChildren);
  }, [children, getRefs]);
  return {
    refChildren,
    refs
  };
}
